import AbstractModelType from '../AbstractModelType';

/**
 * Somewhat naive user-agent parsing.
 * Use feature detection instead if at all possible.
 */
class UserAgent extends AbstractModelType {
  #userAgentString;

  constructor(userAgentString) {
    super(...arguments);

    this.#userAgentString = userAgentString;
    this.isAndroid = Boolean(userAgentString.match(/Android/i));
    this.isChrome = Boolean(userAgentString.match(/Chrome/i));
    this.isFirefox =
      Boolean(userAgentString.match(/Firefox/i)) && !this.isChrome;
    this.isWindows = Boolean(userAgentString.match(/Win/i));
    this.isMac = Boolean(userAgentString.match(/Mac/i));
    this.isLinux = Boolean(userAgentString.match(/Linux/i));
    this.isAndroid = Boolean(userAgentString.match(/Android/i));
    this.isSafari = Boolean(userAgentString.match(/Safari/i)) && !this.isChrome;
    this.isMobile =
      Boolean(
        userAgentString.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i),
      ) ||
      (this.isSafari && 'ontouchstart' in window);
    this.isiOS =
      Boolean(userAgentString.match(/iPhone|iPad|iPod/i)) ||
      (this.isSafari && this.isMobile);
  }

  toString() {
    return this.#userAgentString;
  }
}

export default UserAgent;
